$(function() {
  console.log('Document ready');
  var $slider = $('.js-slider');

  function scrollTo(offset, duration) {
    offset = offset || 0;
    duration = duration || 1000;
    $('html,body').stop().animate({
      scrollTop: offset - 34
    }, duration, 'easeOutCubic');
  }

  $('.js-anchor')
    .on('click', function() {
      var
        id = $(this).attr('href'),
        offset = $(id).offset() ? $(id).offset().top : 0;

      scrollTo(offset);

      return false;
    })
    .each(function() {
      var
        id = $(this).attr('href');

      if (!$(id).length) $(this).parents('li').eq(0).addClass('disabled');
    });

  $('.js-folder')
    .on('click', '.js-folder-close', function() {
      var $t = $(this),
        $p = $t.parents('.js-folder').eq(0),
        $b = $('.js-folder-body', $p),
        $bt = $('.js-folder-btn', $p),
        d = 300;

      $bt.removeClass('open');
      $b.stop().slideUp(d);

      return false;
    })
    .on('click', '.js-folder-btn', function() {
      var $t = $(this),
        $p = $t.parents('.js-folder').eq(0),
        $b = $('.js-folder-body', $p),
        $bt = $('.js-folder-btn', $p),
        t = $bt.index($t),
        d = 300;

      if ($p.data('effect') == 'fade') {
        $bt.removeClass('open');
        $b.stop().fadeOut(d);
        if ($b.eq(t).css('display') == 'none') {
          $b.eq(t).fadeIn(d);
          $t.addClass('open');
        }
      }
      else {
        $bt.removeClass('open');
        $b.stop().slideUp(d);
        if ($b.eq(t).css('display') == 'none') {
          $b.eq(t).slideDown(d);
          $t.addClass('open');
        }
      }

      return false;
    })
    .each(function() {
      var $t = $(this);

      $('.js-folder-btn', $t).removeClass('open');
      $('.js-folder-body', $t).hide();
    });

  if($slider.length) $slider.slick({
    autoplay:      true,
    autoplaySpeed: 4000,
    speed:         1000,
    arrows:        false,
    fade:          true,
    pauseOnHover:  false
  });
});